/* ============================================================
   Trustpilot + "+60.000 glade kunder" i Upcart-kurven (2026-10-14)
   Vises i den grå bund-boks lige over "Gå til betaling".
   Trustpilot-stjernerne er den samme TrustBox som i announcement-
   baren (attributterne kopieres derfra), så score og tekst altid
   er Trustpilots egne. Findes den ikke på siden, vises kun teksten.
   Indlæses fra sections/label-config.liquid.
   ============================================================ */
(function () {
  if (window.__anewUpcartTrust) return;
  window.__anewUpcartTrust = true;

  // --s = skalering af Trustpilot-stjernerne, så stjerner og tekst altid
  // står på én linje - også på smalle telefoner (2026-10-14)
  var CSS =
    '.upcart-footer .anew-trust{--s:1;display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:center;gap:12px;margin:0 0 12px;padding:0;text-align:center;}' +
    '.upcart-footer .anew-trust__stars{flex:0 0 auto;width:calc(203px * var(--s));height:calc(24px * var(--s));overflow:hidden;}' +
    '.upcart-footer .anew-trust__clip{width:203px;height:24px;overflow:hidden;transform:scale(var(--s));transform-origin:left top;}' +
    '.upcart-footer .anew-trust__tp{width:330px;height:24px;margin-left:-127px;}' +
    '.upcart-footer .anew-trust__tp iframe{display:block;}' +
    '.upcart-footer .anew-trust__customers{display:inline-flex;align-items:center;gap:5px;font-size:13px;line-height:1.3;color:#1A1E1A;white-space:nowrap;}' +
    '.upcart-footer .anew-trust__customers strong{font-weight:700;}' +
    '.upcart-footer .anew-trust__heart{width:14px;height:14px;color:#2CA76F;flex:0 0 auto;}' +
    '@media screen and (max-width:480px){.upcart-footer .anew-trust{--s:.82;gap:8px;}.upcart-footer .anew-trust__customers{font-size:12px;gap:4px;}.upcart-footer .anew-trust__heart{width:12px;height:12px;}}' +
    '@media screen and (max-width:360px){.upcart-footer .anew-trust{--s:.72;gap:6px;}.upcart-footer .anew-trust__customers{font-size:11.5px;}}' +
    '@media screen and (max-width:340px){.upcart-footer .anew-trust{--s:.62;gap:5px;}.upcart-footer .anew-trust__customers{font-size:11px;}}';

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var box = null;
  var tpEl = null;
  var tpLoaded = false;

  function sourceWidget() {
    var all = document.querySelectorAll('.trustpilot-widget');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains('anew-trust__tp') && all[i].getAttribute('data-businessunit-id')) return all[i];
    }
    return null;
  }

  function build() {
    box = document.createElement('div');
    box.className = 'anew-trust';

    var src = sourceWidget();
    if (src) {
      tpEl = document.createElement('div');
      for (var i = 0; i < src.attributes.length; i++) {
        var a = src.attributes[i];
        if (a.name === 'class' || a.name === 'style') continue;
        tpEl.setAttribute(a.name, a.value);
      }
      tpEl.className = 'trustpilot-widget anew-trust__tp';
      tpEl.setAttribute('data-style-width', '100%');
      tpEl.setAttribute('data-style-height', '24px');
      // Kun stjerner + Trustpilot-logo: ordet til venstre ("Fremragende")
      // skjules ved at beskære widget'en (Theis' valg 2026-10-14)
      var clip = document.createElement('div');
      clip.className = 'anew-trust__clip';
      clip.appendChild(tpEl);
      var stars = document.createElement('div');
      stars.className = 'anew-trust__stars';
      stars.appendChild(clip);
      box.appendChild(stars);
    }

    var txt = document.createElement('span');
    txt.className = 'anew-trust__customers';
    txt.innerHTML =
      '<svg class="anew-trust__heart" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.8 4.5c2.1 0 3.6 1.1 4.2 2.3h2c.6-1.2 2.1-2.3 4.2-2.3 3.8 0 5.9 3.9 4.4 7.3C19.5 16.4 12 21 12 21z"/></svg>' +
      '<span><strong>+60.000</strong> glade kunder</span>';
    box.appendChild(txt);
  }

  function loadWidget() {
    if (tpLoaded || !tpEl || !window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;
    tpLoaded = true;
    try { window.Trustpilot.loadFromElement(tpEl, true); } catch (e) {}
  }

  function place() {
    var footer = document.querySelector('.upcart-footer');
    if (!footer) return;
    var btn = footer.querySelector('.upcart-checkout-button-container');
    if (!btn) return;
    var target = btn;
    while (target.parentElement && target.parentElement !== footer) target = target.parentElement;
    if (target.parentElement !== footer) return;
    if (!box) build();
    if (box.parentElement === footer && box.nextElementSibling === target) { loadWidget(); return; }
    footer.insertBefore(box, target);
    if (box.parentElement === footer) {
      // Et flyttet iframe genindlæses - hent widget'en på ny
      if (tpEl && tpEl.querySelector('iframe')) { tpEl.innerHTML = ''; tpLoaded = false; }
      loadWidget();
    }
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; place(); }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Trustpilots script kan komme efter os
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (box && box.parentElement) loadWidget();
    if (tpLoaded || tries > 20) clearInterval(t);
  }, 500);

  place();
})();
